<template>
  <div>
    <portal
      v-if="targetel && shouldShowRaqButton"
      :name="name"
      :target-el="'#' + targetel"
      slim
    >
      <button
        data-type="booking interest"
        data-name="raq"
        class="button is-subtle cta"
        @click.prevent="[
          toggleModal(tour, tourselecteddate, tourdepartureid, $event),
          dataLayerRAQOpen()
        ]"
        v-text="labels.button"
      />
    </portal>
    <button
      v-if="!targetel"
      class="button is-subtle is-pulled-right cta"
      @click.prevent="[
        toggleModal(tour, tourselecteddate, tourdepartureid, $event),
        dataLayerRAQOpen()
      ]"
      v-text="labels.button"
    />
  </div>
</template>
<script>
import EventBus from '../../vue-functions/event-bus';
export default {
  props: {
    tour: Object,
    labels: Object,
    tourselecteddate: String,
    tourdepartureid: String,
    name: String,
    targetel: String
  },
  computed: {
    regionCode() {
      const path = window.location.pathname;
      const match = path.match(/^\/(en-(us|ca|au|gb))/i);
      return match ? match[1].toLowerCase() : null;
    },
    shouldShowRaqButton() {
      if (!this.tour) return false;

      const isTrafalgarCruise = this.tour.brand === 'trafalgar' && this.tour.isShipTour;
      if (isTrafalgarCruise) {
        return this.regionCode === 'en-us' || this.regionCode === 'en-ca';
      }

      return true;
    }
  },
  methods: {
    toggleModal(tour, tourselecteddate, tourdepartureid, event) {
      EventBus.$emit('TOGGLE_RAQ_MODAL', tour, tourselecteddate, tourdepartureid);
      const target = event.target;
      EventBus.$emit('update-raq-target', target);

      this.$nextTick(() => {
        window.lcw?.refresh?.();
      });
    },
    dataLayerRAQOpen() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'RAQ Button Clicked From Trip' });
    }
  }
};
</script>
